import { render, staticRenderFns } from "./ExerciseListCard.vue?vue&type=template&id=b21020d8"
import script from "./ExerciseListCard.vue?vue&type=script&lang=js"
export * from "./ExerciseListCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports